import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Space, Tag, Select, Card, Button, Checkbox } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { remove } from 'lodash';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable';
import * as custom_queries from "../../../../Custom_queries/queries";
import '../../../../styles/Comportamientos.css';
import { usePagination } from '../../../../hooks/useFiltersPagination.js';



const { Search } = Input;

const Comportamientos = (
  {
    typeFilter,
    setTypeFilter,
    querieCat,
    nameFilter
  }
) => {
  const [selectedData1, setSelectedData1] = useState();
  const [searchValue1, setSearchValue1] = useState();
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false)
  const [isLike, setIsLike] = useState(true)
  const [searchPosition, setSearchPosition] = useState(3)
  const [searchBehavior, setSearchBehavior] = useState(false)

  const fetchFilter1 = async (filter = null, isLike, searchPosition) => {
    try {
      let isLikeValue = filter ? isLike : false;
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { limit: 1000, query: "${querieCat}", name_filter: "${filter}", is_like: ${isLikeValue}, like_position: ${searchPosition} }){
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const result = response.data.getFiltersRedshift;
  
      if (result[0].id_statement !== null) {
        getValues({ idStatement: result[0].id_statement });
      } else {
        const newData = result.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData1(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSelectAll1 = (e) => {
    if (e.target.checked) {
      setSelectedsData1(selectedData1);
      setTypeFilter(selectedData1);
    } else {
      setSelectedsData1([]);
      setTypeFilter([]);
    }
  };
  
  useEffect(() => {
    setShowLoadingData1(true)
    fetchFilter1(searchValue1, isLike, searchPosition)
  }, [searchBehavior])
  
  const getValues = async ({ idStatement }) => {
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${querieCat}"}){
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });
      response = result.data.getData;
      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Esperar 5 segundos antes de hacer la siguiente petición
      }
    }
    setSelectedData1(response.length > 0 && response[0].value_filter !== "Sin Datos" ? response : [])
    setShowLoadingData1(false)
  };

  const handleChange = (value) => {
    switch (value) {
      case 1:
        setIsLike(true)
        setSearchPosition(3)
        break
      case 2:
        setIsLike(true)
        setSearchPosition(0)
        break
      case 3:
        setIsLike(true)
        setSearchPosition(2)
        break
      case 4:
        setIsLike(true)
        setSearchPosition(1)
        break
      default:
        break
    }
  };

  const filters = [
    {
      title: 'Comportamientos',
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: typeFilter,
      setFilterComponent: setTypeFilter,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1,
      setShowLoadingData: setShowLoadingData1,
      handleSelectAll: handleSelectAll1,
    },

  ];

  const {
    currentPage,
    handleNext,
    handlePrev,
    visibleItems: visibleFilters,
    endIndex,
  } = usePagination(filters);

  return (
    <Row className="Comportamientos" gutter={16}>
      <Col span={8}>
        <Space direction="vertical" size="middle" style={{ width: '150%' }}>
          <Row justify="start" gutter={16}>
            <Col>
              <Select
                defaultValue= {`Búsqueda por palabra contenida en ${nameFilter}:`}
                className="ant-select"
                onChange={handleChange}
                bordered={false}
                dropdownStyle={{ borderRadius: '5px'}}
                options={[
                  {
                    value: 1,
                    label: `Búsqueda por palabra contenida en ${nameFilter}:`,
                  },
                  {
                    value: 2,
                    label: `Búsqueda por palabra exacta en ${nameFilter}:`,
                  },
                  {
                    value: 3,
                    label: `Búsqueda por palabra al inicio en ${nameFilter}:`,
                  },
                  {
                    value: 4,
                    label: `Búsqueda por palabra al final en ${nameFilter}:`,
                  },
                ]}
              />
            </Col>
          </Row>
          <Row justify="start">
            <Col span={16} style={{marginTop: '-5px'}}>
                <Search
                  placeholder="Buscar"
                  allowClear
                  loading={showLoadingData1}
                  onSearch={(value) => {
                    setShowLoadingData1(true);
                    setSearchValue1(value);
                    setSearchBehavior(!searchBehavior);
                  }}
                />
            </Col>
          </Row>
        </Space>
          <Row justify="start">
            <Col style={{marginTop: '-10px'}}>
              {visibleFilters.map((filter, index) => (
                  <FiltersTable
                    selectedData={filter.selectedData}
                    setSelectedData={filter.setSelectedData}
                    selectedsData={filter.selectedsData}
                    setSelectedsData={filter.setSelectedsData}
                    filterComponent={filter.filterComponent}
                    setFilterComponent={filter.setFilterComponent}
                    banderaTags={filter.banderaTags}
                    setBanderaTags={filter.setBanderaTags}
                    showLoadingData={filter.showLoadingData}
                    setShowLoadingData={filter.setShowLoadingData}
                  />
              ))}
            </Col>
          </Row>
        {filters.length > 2 && (
          <Row style={{ marginTop: '20px', display: 'flex', justifyContent: 'center',  marginLeft: '-415px' }}>
            <div style={{ width: '122px', display: 'flex', justifyContent: 'space-between' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.length}
              />
            </div>
          </Row>
        )}
      </Col>

      <Col span={12} offset={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Card
                style={{
                  width: 500,
                  height: 300,
                  marginTop: 40,
                  overflow: 'auto',
                  borderRadius: 15,
                  marginLeft: 'auto',
                }}
              >
              {
                selectedsData1 && selectedsData1.map(({ key, value_filter, type }) => (
                  <Tag
                    key={`${key}-${value_filter}`}
                    className="TagsSelectFilters"
                    closable
                    onClose={e => {
                      remove(selectedsData1, { value_filter: value_filter });
                      setSelectedsData1([...selectedsData1]);
                      setBanderaTags1(true);
                    }}
                  >
                    {value_filter}
                  </Tag>
                ))
              }
          </Card>
      </Col>
    </Row>
  );

}
export default Comportamientos;